export default {
  SET_AFFILIATE(state, affiliates) {
    state.affiliates = affiliates
  },
  SET_AFFILIATE_COUNT(state, count) {
    state.affiliatesCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const affiliateIndex = state.affiliates.findIndex(u => u.id === itemId)
    state.affiliates.splice(affiliateIndex, 1)
  }
}
